import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      opacityBlack25: string;
      grey1: string;
      grey2: string;
      grey3: string;
      grey4: string;
      grey5: string;
      grey6: string;
      grey7: string;
      grey8: string;
      grey9: string;
      violet: string;
      black: Record<number, string>;
      primaryDark2: string;
      red?: string;
    };
    actions: {
      go: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      opacityBlack25?: string;
      grey1?: string;
      grey2?: string;
      grey3?: string;
      grey4?: string;
      grey5?: string;
      grey6?: string;
      grey7?: string;
      grey8?: string;
      grey9?: string;
      violet?: string;
      black?: Record<number, string>;
      primaryDark2?: string;
      red?: string;
    };
    actions?: {
      go?: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    mode: 'light',
    common: {
      black: '#1C1D22',
    },
    primary: {
      main: '#0078D4',
      dark: '#0C6EB9',
    },
    secondary: {
      main: '#2C2D33',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#C4655F',
      light: '#FFA3A3',
    },
    actions: {
      go: '#519C66',
    },
    warning: {
      main: '#F78400',
    },
    success: {
      main: '#D6F9D7',
    },
    info: {
      main: '#D0E6FE',
      dark: '#95C6FF',
    },
    custom: {
      opacityBlack25: '#00000017',
      grey1: '#DBE0E9',
      grey2: '#C9CDD2',
      grey3: '#F0F0F0',
      grey4: '#5E6366',
      grey5: '#DBDDE5',
      grey6: '#E8E8E8',
      grey7: '#F3F3F3',
      grey8: '#E1E1E1',
      grey9: '#E0E0E0',
      violet: '#838EBE',
      black: {
        100: '#1C1D22',
        90: '#2C2D33',
        80: '#33343A',
        70: '#37393F',
        60: '#45464E',
        50: '#53545C',
        40: '#6E7079',
        30: '#8B8D97',
        20: '#A6A8B1',
        10: '#BEC0CA',
      },
      primaryDark2: '#04599B',
      red: '#DC3A3A',
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
        },
      },
    },
  },
});
